import { Grid, Stack } from '@mui/material'
import React, { FC } from 'react'

import EntriesByStatusListContainer from '../../components/Inspections/EntriesByStatusListContainer'
import Sidebar from './Sidebar'

const BodyContainer: FC = () => {
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        md={9}
        paddingRight={{ xs: 0, md: 2 }}
        paddingBottom={{ xs: 2, md: 0 }}>
        <Stack>
          <EntriesByStatusListContainer />
        </Stack>
      </Grid>
      <Grid item xs={12} md={3}>
        <Sidebar />
      </Grid>
    </Grid>
  )
}

export default BodyContainer
